/**
 * Subtle Union Jack accent — small, muted, luxury-appropriate.
 */
export const UnionJack = ({ width = 18, className = "", muted = false }) => (
    <svg
        width={width}
        height={Math.round(width * 0.61)}
        viewBox="0 0 18 11"
        className={`inline-block flex-shrink-0 ${className}`}
        aria-label="United Kingdom flag"
        role="img"
        style={muted ? { opacity: 0.75, filter: "saturate(0.75)" } : undefined}
    >
        <rect width="18" height="11" fill="#0E1A2B" rx="1" />
        <path d="M0 0 L18 11 M18 0 L0 11" stroke="#F6F1E7" strokeWidth="2.2" />
        <path d="M0 0 L18 11 M18 0 L0 11" stroke="#7A1F2B" strokeWidth="0.9" />
        <path d="M9 0 V11 M0 5.5 H18" stroke="#F6F1E7" strokeWidth="3.4" />
        <path d="M9 0 V11 M0 5.5 H18" stroke="#7A1F2B" strokeWidth="1.8" />
    </svg>
);
